"use client";;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/portfolio/:slug\",\"regex\":\"^/portfolio/([^/]+)$\",\"paramNames\":[\"slug\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/chat\"},{\"path\":\"/contact\"},{\"path\":\"/portfolio\"},{\"path\":\"/privacy\"},{\"path\":\"/service\"},{\"path\":\"/terms\"},{\"path\":\"/tools\"}]}";

if (typeof window !== "undefined") {
  const consent = document.cookie.includes("cookie-consent=true");

  if (consent) {
    import("./lib/utils/sentry-client-init").then((mod) => {
      mod.initSentryClient();
    });
  }
}

export const onRouterTransitionStart = () => {};
